// TODO: Confirm latest ids
export var DTS_MIDDLE_PRICE_TARGET_ID = '1PoVEUH97XRICtBoMQkBCIRw'; // 500$

export var DTS_LOW_PRICE_TARGET_ID = '1PxtLoH97XRICtBoTjTm4zuJ'; // 300$

export var DTS_TOP_PRICE_TARGET_ID = '1PxtMRH97XRICtBoPdEZNnPM'; // 1000$

export var DTS_MIDDLE_PRICE_TARGET_LABEL = 'Get Showcase for $500';
export var DTS_LOW_PRICE_TARGET_LABEL = 'Get Showcase for $300';
export var DTS_TOP_PRICE_TARGET_LABEL = 'Get Showcase for $1000';
//# sourceMappingURL=constants.js.map